import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
const NAMES = ['Ana', 'Laura', 'Sofía', 'Valentina', 'Camila', 'Martina', 'Lucía', 'Fernanda', 'Daniela', 'Mariana'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Misiones', 'Neuquén', 'San Juan'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    province: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomProvince = PROVINCES[Math.floor(Math.random() * PROVINCES.length)];
      setCurrentData({
        name: randomName,
        province: randomProvince
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    // Setup recurring interval (every 12-20 seconds)
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-439">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-center gap-4 max-w-sm" data-id="element-440">
          <div className="bg-green-100 w-10 h-10 rounded-full flex items-center justify-center shrink-0" data-id="element-441">
            <MapPin className="w-5 h-5 text-green-600" data-id="element-442" />
          </div>
          <div data-id="element-443">
            <p className="text-sm font-opensans text-gray-800" data-id="element-444">
              <span className="font-bold" data-id="element-445">{currentData.name}</span> de{' '}
              {currentData.province}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-446">
              acaba de comprar este programa
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};